import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { components } from 'react-select';
import isFunction from "lodash/isFunction";

export const CustomMenuList = (
  props,
  isOptionError
) => {
  return (
    <components.MenuList {...props}>
      {!isOptionError && props.children}
      {isOptionError && (
        <div style={{ padding: '72px 16px' }} className="text-center text-wrap text-gray-600">
          <div className="heavy">
            <FormattedMessage
              id="shared_components.activity-input.no-activity-message"
              defaultMessage="We don't recognize that activity."
            />
          </div>
          <div>
            <FormattedMessage
              id="shared_components.activity-input.no-activity-message-subheader"
              defaultMessage="Try describing it differently and select from our activities."
            />
          </div>
        </div>
      )}
    </components.MenuList>
  );
};
